
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 142.55 224"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"レイヤー 1"}},[_c('path',{attrs:{"d":"M88.81 206.26c9.84 0 22.3 0 30.5-.33 5.57-.32 13.11-.65 15.41-.65 5.57 0 6.55 1.64 6.55 7.87v2.95c0 6.23-1 7.87-6.55 7.87-6.89 0-28.53-.33-45.91-.33H50.45c-16.06 0-40.32.33-42.62.33-5.57 0-6.56-1.64-6.56-8.2 0-7.21 1-9.18 6.23-13.77 5.58-4.59 11.48-10.16 16.72-14.75C79.31 136.43 120 98.39 120 61c0-24.59-18-42-48.52-42A71.78 71.78 0 0021 40c-2.68 2.66-4.32 4-6 4s-2.91-1.34-5.53-4l-3.61-3.6c-2.62-2.63-3.28-4.27-3.28-5.91S3.9 27.25 6.52 25C23.24 10.2 45.54 0 73.4 0 116.35 0 140 26.92 140 58.07c0 46.55-42.66 87.21-104 141.63-2.63 2.3-3.28 3.61-3.28 4.6q0 2 5.9 2z","fill":"#fff","opacity":".3"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h142.55v224H0z"}})])])])
          )
        }
      }
    